import { FC } from 'react';
import { Tag } from '../../../../core/components/atoms/Tag';
import { getFilterType } from '../../utils';
import { Typography } from '../../../../core/components/molecules/Typography';

interface ITagsTypeProps {
  types: string[];
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
}

export const RenderTagsType: FC<ITagsTypeProps> = ({
  types,
  selectedType,
  onSelectType,
}) => {
  if (types.length === 0) {
    return null;
  }

  return (
    <div className='flex w-full flex-row flex-wrap gap-md'>
      <Typography className='text-h4 text-mono-color-dark'>
        Filtrar por:
      </Typography>
      <Tag
        variant={selectedType === null ? 'primary' : 'transparent'}
        className='cursor-pointer rounded-lg px-2 border-hairline border-color-brand-primary'
        onClick={() => onSelectType(null)}
      >
        Todos
      </Tag>
      {types.map((type) => (
        <Tag
          key={type}
          variant={selectedType === type ? 'primary' : 'transparent'}
          className='cursor-pointer rounded-lg px-2 border-hairline border-color-brand-primary'
          onClick={() => onSelectType(type)}
        >
          {getFilterType(type)}
        </Tag>
      ))}
    </div>
  );
};
